const animalListingAPIUrl = `/api/animal_os/animals`
//const animalListingAPIUrl = `https://rspcaact.my.salesforce.com/services/apexrest/RetrieveAnimals`
const animalDetailBaseAPIUrl = `/api/animal_os/animal`;
//const animalDetailBaseAPIUrl = `https://rspcaact.my.salesforce.com/services/data/v61.0/sobjects/animalos__Animal__c`;
const shelterlBaseAPIUrl = `/api/animal_os/shelter`;
//const shelterlBaseAPIUrl = `https://rspcaact.my.salesforce.com/services/apexrest/RetrieveShelters`;

const animalListingDefaultParams = {
    AnimalStatus: "Available For Adoption;Available for Adoption-In Foster;Available for Adoption-No web Prescence;Available for Adoption-Offsite;Trail adoption",
    Limit: 6,
    timeStamp: Date.now()
};

const { sf_token_expiry } = drupalSettings;


/*const fetchAccessToken = async () => {
    const getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    };

    const setCookie = (name, value, expiryDate) => {
        console.log(expiryDate);
        const expires = `expires=${expiryDate.toUTCString()}`;
        document.cookie = `${name}=${value}; ${expires}; path=/`;
    };

    let token = getCookie('access_token');
    let tokenExpiry = getCookie('access_token_expiry');

    // Check if token is present and still valid
    if (token && tokenExpiry && new Date().getTime() < parseInt(tokenExpiry)) {
        console.log(`From cookies and it will expire in ${new Date(parseInt(tokenExpiry))}`);
        return token;
    } else {
        // Fetch token from server
        const response = await fetch('/api/animal_os/access_token', { method: "POST" });
        const { data } = await response.json();
        const { token, issue_date } = data;

        const issueDate = new Date(issue_date);
        const expiryDate = new Date(issueDate.getTime() + sf_token_expiry * 60 * 1000); // sf_token_expiry is in minutes

        console.log('Issue date is', issue_date);
        console.log('Expiry date is', expiryDate);
        console.log('Expiry date timestamp is', expiryDate.getTime());

        setCookie('access_token', token, expiryDate);
        setCookie('access_token_expiry', expiryDate.getTime(), expiryDate);
        console.log(`From server`);
        return token;
    }
};*/

/*const authHeader = async () => {
    const token = await fetchAccessToken();
    const httpHeader = new Headers();
    httpHeader.append("Authorization", `"Bearer ${token}`);
    console.log('Token', token);
    return httpHeader;
}*/


/*const fetchWithRetry = async (url, options, retryCount = 1) => {
    try {
        const response = await fetch(url, options);

        if (!response.ok) {
            if (response.status === 401 && retryCount > 0) {
                // Retry once if authentication failed
                console.warn(`Authentication failed. Retrying...`);
                return fetchWithRetry(url, options, retryCount - 1);
            }
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error(`Error while fetching data: ${error}`);
        throw error;
    }
};*/

const fetchBackendData = async (url, options) => {
    try {
        const response = await fetch(url, options);

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const json_response = await response.json();

        if (json_response.data) {
            return json_response.data;
        }

        return [];
    } catch (error) {
        console.error(`Error while fetching data: ${error}`);
        throw error;
    }
};

export const fetchAnimalForAdoption = async (params) => {
    // Merge defaultParams with params
    const mergedParams = { ...animalListingDefaultParams, ...params };

    // Convert mergedParams object to URLSearchParams
    const urlParams = new URLSearchParams(mergedParams);

    // Create the full URL with query parameters
    const URL = `${animalListingAPIUrl}?${urlParams.toString()}`;

    const options = {
        method: "GET",
        //headers: await authHeader(),
        redirect: "follow"
    };

    return fetchBackendData(URL, options);
};

export const fetchAnimalDetails = async (petId) => {
    const urlParams = new URLSearchParams({ petId });
    const baseURL = `${animalDetailBaseAPIUrl}?${urlParams.toString()}`;

    const options = {
        method: "GET",
        //headers: await authHeader(),
        redirect: "follow"
    };

    return fetchBackendData(baseURL, options);
};

export const fetchShelter = async (shelterId) => {
    const baseURL = shelterlBaseAPIUrl;

    const options = {
        method: "GET",
        //headers: await authHeader(),
        redirect: "follow"
    };

    const json = await fetchBackendData(baseURL, options);
    const { locations } = json;

    return locations.find(x => x.Id == shelterId);
};

export const fetchFilterData = async () => {
    return new Promise((resolve, reject) => {
        resolve({
            animalType: [
                "Dog",
                "Cat",
                "Dog",
                "Rabbit",
                "Fish",
                "Bird",
                "Dog",
                "Cat"
            ],
            location: [
                "Weston Shelter",
                "Queanbeyan Shelter",
                "Gungahlin Shelter",
                "Tuggeranong Shelter"
            ]
        });
    });
}
